package dev.wyns.ventrova.ui.components

import androidx.compose.runtime.Composable
import dev.wyns.ventrova.app.Filters
import dev.wyns.ventrova.app.StrictnessStop
import dev.wyns.ventrova.data.model.VeganLevel
import dev.wyns.ventrova.resources.Res
import dev.wyns.ventrova.resources.filter_all_levels
import dev.wyns.ventrova.resources.filter_distance_all
import dev.wyns.ventrova.resources.filter_open_now
import dev.wyns.ventrova.resources.filter_stop_custom
import dev.wyns.ventrova.resources.filter_stop_options
import dev.wyns.ventrova.resources.filter_stop_options_description
import dev.wyns.ventrova.resources.filter_stop_vegan
import dev.wyns.ventrova.resources.filter_stop_vegan_description
import dev.wyns.ventrova.resources.filter_stop_vegetarian
import dev.wyns.ventrova.resources.filter_stop_vegetarian_description
import dev.wyns.ventrova.resources.filter_up_to
import dev.wyns.ventrova.ui.theme.distanceLabel
import dev.wyns.ventrova.ui.theme.label
import dev.wyns.ventrova.ui.theme.shortLabel
import org.jetbrains.compose.resources.stringResource

/** "Veggie, Options · open now · ≤ 1 km", or "All levels". */
@Composable
fun filterSummary(filters: Filters): String {
    val parts = buildList {
        add(
            if (filters.levels.isEmpty()) {
                stringResource(Res.string.filter_all_levels)
            } else {
                VeganLevel.entries.filter { it in filters.levels }.map { stringResource(it.shortLabel) }.joinToString(", ")
            },
        )
        if (filters.openNow) add(stringResource(Res.string.filter_open_now).lowercase())
        filters.radiusKm?.let { add(stringResource(Res.string.filter_up_to, radiusLabel(it))) }
        if (filters.categories.isNotEmpty()) add(filters.categories.map { stringResource(it.label) }.joinToString(", "))
    }
    return parts.joinToString(" · ")
}

/** "500 m", "1 km"; "All" for no limit. */
@Composable
fun radiusLabel(km: Double?): String = if (km == null) stringResource(Res.string.filter_distance_all) else distanceLabel(km * 1000).replace(",0 km", " km").replace(".0 km", " km")

/** Short label of a slider stop, e.g. "Veggie". */
@Composable
fun stopLabel(stop: StrictnessStop): String = stringResource(
    when (stop) {
        StrictnessStop.VeganOptions -> Res.string.filter_stop_options
        StrictnessStop.Vegetarian -> Res.string.filter_stop_vegetarian
        StrictnessStop.Vegan -> Res.string.filter_stop_vegan
    },
)

/** What the current slider position means, e.g. "At least vegetarian". */
@Composable
fun stopDescription(stop: StrictnessStop?): String = stringResource(
    when (stop) {
        StrictnessStop.VeganOptions -> Res.string.filter_stop_options_description
        StrictnessStop.Vegetarian -> Res.string.filter_stop_vegetarian_description
        StrictnessStop.Vegan -> Res.string.filter_stop_vegan_description
        null -> Res.string.filter_stop_custom
    },
)
